import { render } from "./Main.vue?vue&type=template&id=5f0bb85e&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=5f0bb85e&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=5f0bb85e&lang=css"
script.render = render
script.__scopeId = "data-v-5f0bb85e"

export default script